import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
	selector: 'app-open-notification-wrapper',
	templateUrl: './open-notification-wrapper.component.html',
	styleUrls: ['./open-notification-wrapper.component.scss'],
})
export class OpenNotificationWrapperComponent implements OnInit {
	constructor(private elRef: ElementRef) {}

	public ngOnInit(): void {
		const mfeNode = this.elRef.nativeElement.querySelector('mfe-loader');
		mfeNode.preventUnmount = true;
	}
}
